// Array of country objects for the flag dropdown.

// Here is the criteria for the plugin to support a given country/territory
// - It has an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
// - It has it's own country calling code (it is not a sub-region of another country): https://en.wikipedia.org/wiki/List_of_country_calling_codes
// - It has a flag in the region-flags project: https://github.com/behdad/region-flags/tree/gh-pages/png
// - It is supported by libphonenumber (it must be listed on this page): https://github.com/googlei18n/libphonenumber/blob/master/resources/ShortNumberMetadata.xml

// Each country array has the following information:
// [
//    Country name,
//    iso2 code,
//    International dial code,
//    Order (if >1 country with same dial code),
//    Area codes
// ]
const AllCountries = [
  [
    'Afghanistan (‫افغانستان‬‎)',
    'af',
    '93',
    '070 123 4567',
  ],
  [
    'Albania (Shqipëri)',
    'al',
    '355',
    '066 123 4567',
  ],
  [
    'Algeria (‫الجزائر‬‎)',
    'dz',
    '213',
    '0551 23 45 67',
  ],
  [
    'American Samoa',
    'as',
    '1684',
    '684 733 1234',
  ],
  [
    'Andorra',
    'ad',
    '376',
    '312 345',
  ],
  [
    'Angola',
    'ao',
    '244',
    '923 123 456',
  ],
  [
    'Anguilla',
    'ai',
    '1264',
    '264 235 1234',
  ],
  [
    'Antigua and Barbuda',
    'ag',
    '1268',
    '268 464 1234',
  ],
  [
    'Argentina',
    'ar',
    '54',
    '011 15 2345 6789',
  ],
  [
    'Armenia (Հայաստան)',
    'am',
    '374',
    '077 123456',
  ],
  [
    'Aruba',
    'aw',
    '297',
    '560 1234',
  ],
  [
    'Australia',
    'au',
    '61',
    '0412 345 678',
    0,
  ],
  [
    'Austria (Österreich)',
    'at',
    '43',
    '0664 123456',
  ],
  [
    'Azerbaijan (Azərbaycan)',
    'az',
    '994',
    '040 123 45 67',
  ],
  [
    'Bahamas',
    'bs',
    '1242',
    '242 359 1234',
  ],
  [
    'Bahrain (‫البحرين‬‎)',
    'bh',
    '973',
    '3600 1234',
  ],
  [
    'Bangladesh (বাংলাদেশ)',
    'bd',
    '880',
    '01812 345678',
  ],
  [
    'Barbados',
    'bb',
    '1246',
    '246 250 1234',
  ],
  [
    'Belarus (Беларусь)',
    'by',
    '375',
    '8 029 491 19 11',
  ],
  [
    'Belgium (België)',
    'be',
    '32',
    '0470 12 34 56',
  ],
  [
    'Belize',
    'bz',
    '501',
    '622 1234',
  ],
  [
    'Benin (Bénin)',
    'bj',
    '229',
    '90 01 12 34',
  ],
  [
    'Bermuda',
    'bm',
    '1441',
    '441 370 1234',
  ],
  [
    'Bhutan (འབྲུག)',
    'bt',
    '975',
    '17 12 34 56',
  ],
  [
    'Bolivia',
    'bo',
    '591',
    '71234567',
  ],
  [
    'Bosnia and Herzegovina (Босна и Херцеговина)',
    'ba',
    '387',
    '061 123 456',
  ],
  [
    'Botswana',
    'bw',
    '267',
    '71 123 456',
  ],
  [
    'Brazil (Brasil)',
    'br',
    '55',
    '11 96123 4567',
  ],
  [
    'British Indian Ocean Territory',
    'io',
    '246',
    '380 1234',
  ],
  [
    'British Virgin Islands',
    'vg',
    '1284',
    '284 300 1234',
  ],
  [
    'Brunei',
    'bn',
    '673',
    '712 3456',
  ],
  [
    'Bulgaria (България)',
    'bg',
    '359',
    '048 123 456',
  ],
  [
    'Burkina Faso',
    'bf',
    '226',
    '70 12 34 56',
  ],
  [
    'Burundi (Uburundi)',
    'bi',
    '257',
    '79 56 12 34',
  ],
  [
    'Cambodia (កម្ពុជា)',
    'kh',
    '855',
    '091 234 567',
  ],
  [
    'Cameroon (Cameroun)',
    'cm',
    '237',
    '6 71 23 45 67',
  ],
  [
    'Canada',
    'ca',
    '1',
    '204 234 5678',
    1,
    ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905'],
  ],
  [
    'Cape Verde (Kabu Verdi)',
    'cv',
    '238',
    '991 12 34',
  ],
  [
    'Caribbean Netherlands',
    'bq',
    '599',
    '318 1234',
    1,
  ],
  [
    'Cayman Islands',
    'ky',
    '1345',
    '345 323 1234',
  ],
  [
    'Central African Republic (République centrafricaine)',
    'cf',
    '236',
    '70 01 23 45',
  ],
  [
    'Chad (Tchad)',
    'td',
    '235',
    '63 01 23 45',
  ],
  [
    'Chile',
    'cl',
    '56',
    '09 6123 4567',
  ],
  [
    'China (中国)',
    'cn',
    '86',
    '131 2345 6789',
  ],
  [
    'Christmas Island',
    'cx',
    '61',
    '0412 345 678',
    2,
  ],
  [
    'Cocos (Keeling) Islands',
    'cc',
    '61',
    '0412 345 678',
    1,
  ],
  [
    'Colombia',
    'co',
    '57',
    '321 1234567',
  ],
  [
    'Comoros (‫جزر القمر‬‎)',
    'km',
    '269',
    '321 23 45',
  ],
  [
    'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    'cd',
    '243',
    '0991 234 567',
  ],
  [
    'Congo (Republic) (Congo-Brazzaville)',
    'cg',
    '242',
    '06 123 4567',
  ],
  [
    'Cook Islands',
    'ck',
    '682',
    '71 234',
  ],
  [
    'Costa Rica',
    'cr',
    '506',
    '8312 3456',
  ],
  [
    'Côte d’Ivoire',
    'ci',
    '225',
    '01 23 45 67',
  ],
  [
    'Croatia (Hrvatska)',
    'hr',
    '385',
    '091 234 5678',
  ],
  [
    'Cuba',
    'cu',
    '53',
    '05 1234567',
  ],
  [
    'Curaçao',
    'cw',
    '599',
    '9 518 1234',
    0,
  ],
  [
    'Cyprus (Κύπρος)',
    'cy',
    '357',
    '96 123456',
  ],
  [
    'Czech Republic (Česká republika)',
    'cz',
    '420',
    '601 123 456',
  ],
  [
    'Denmark (Danmark)',
    'dk',
    '45',
    '20 12 34 56',
  ],
  [
    'Djibouti',
    'dj',
    '253',
    '77 83 10 01',
  ],
  [
    'Dominica',
    'dm',
    '1767',
    '767 225 1234',
  ],
  [
    'Dominican Republic (República Dominicana)',
    'do',
    '1',
    '809 234 5678',
    2,
    ['809', '829', '849'],
  ],
  [
    'Ecuador',
    'ec',
    '593',
    '099 123 4567',
  ],
  [
    'Egypt (‫مصر‬‎)',
    'eg',
    '20',
    '0100 123 4567',
  ],
  [
    'El Salvador',
    'sv',
    '503',
    '7012 3456',
  ],
  [
    'Equatorial Guinea (Guinea Ecuatorial)',
    'gq',
    '240',
    '222 123 456',
  ],
  [
    'Eritrea',
    'er',
    '291',
    '07 123 456',
  ],
  [
    'Estonia (Eesti)',
    'ee',
    '372',
    '5123 4567',
  ],
  [
    'Ethiopia',
    'et',
    '251',
    '091 123 4567',
  ],
  [
    'Falkland Islands (Islas Malvinas)',
    'fk',
    '500',
    '51234',
  ],
  [
    'Faroe Islands (Føroyar)',
    'fo',
    '298',
    '211234',
  ],
  [
    'Fiji',
    'fj',
    '679',
    '701 2345',
  ],
  [
    'Finland (Suomi)',
    'fi',
    '358',
    '041 2345678',
    0,
  ],
  [
    'France',
    'fr',
    '33',
    '06 12 34 56 78',
  ],
  [
    'French Guiana (Guyane française)',
    'gf',
    '594',
    '0694 20 12 34',
  ],
  [
    'French Polynesia (Polynésie française)',
    'pf',
    '689',
    '87 12 34 56',
  ],
  [
    'Gabon',
    'ga',
    '241',
    '06 03 12 34',
  ],
  [
    'Gambia',
    'gm',
    '220',
    '301 2345',
  ],
  [
    'Georgia (საქართველო)',
    'ge',
    '995',
    '555 12 34 56',
  ],
  [
    'Germany (Deutschland)',
    'de',
    '49',
    '30 1234567',
  ],
  [
    'Ghana (Gaana)',
    'gh',
    '233',
    '023 123 4567',
  ],
  [
    'Gibraltar',
    'gi',
    '350',
    '57123456',
  ],
  [
    'Greece (Ελλάδα)',
    'gr',
    '30',
    '691 234 5678',
  ],
  [
    'Greenland (Kalaallit Nunaat)',
    'gl',
    '299',
    '22 12 34',
  ],
  [
    'Grenada',
    'gd',
    '1473',
    '473 403 1234',
  ],
  [
    'Guadeloupe',
    'gp',
    '590',
    '0690 30 1234',
    0,
  ],
  [
    'Guam',
    'gu',
    '1671',
    '671 300 1234',
  ],
  [
    'Guatemala',
    'gt',
    '502',
    '5123 4567',
  ],
  [
    'Guernsey',
    'gg',
    '44',
    '07781 123456',
    1,
  ],
  [
    'Guinea (Guinée)',
    'gn',
    '224',
    '601 12 34 56',
  ],
  [
    'Guinea-Bissau (Guiné Bissau)',
    'gw',
    '245',
    '955 012 345',
  ],
  [
    'Guyana',
    'gy',
    '592',
    '609 1234',
  ],
  [
    'Haiti',
    'ht',
    '509',
    '34 10 1234',
  ],
  [
    'Honduras',
    'hn',
    '504',
    '9123 4567',
  ],
  [
    'Hong Kong (香港)',
    'hk',
    '852',
    '5123 4567',
  ],
  [
    'Hungary (Magyarország)',
    'hu',
    '36',
    '20 123 4567',
  ],
  [
    'Iceland (Ísland)',
    'is',
    '354',
    '611 1234',
  ],
  [
    'India (भारत)',
    'in',
    '91',
    '099876 54321',
  ],
  [
    'Indonesia',
    'id',
    '62',
    '0812 345 678',
  ],
  [
    'Iran (‫ایران‬‎)',
    'ir',
    '98',
    '0912 345 6789',
  ],
  [
    'Iraq (‫العراق‬‎)',
    'iq',
    '964',
    '0791 234 5678',
  ],
  [
    'Ireland',
    'ie',
    '353',
    '085 012 3456',
  ],
  [
    'Isle of Man',
    'im',
    '44',
    '07924 123456',
    2,
  ],
  [
    'Israel (‫ישראל‬‎)',
    'il',
    '972',
    '050 123 4567',
  ],
  [
    'Italy (Italia)',
    'it',
    '39',
    '312 345 6789',
    0,
  ],
  [
    'Jamaica',
    'jm',
    '1876',
    '876 210 1234',
  ],
  [
    'Japan (日本)',
    'jp',
    '81',
    '090 1234 5678',
  ],
  [
    'Jersey',
    'je',
    '44',
    '07797 123456',
    3,
  ],
  [
    'Jordan (‫الأردن‬‎)',
    'jo',
    '962',
    '07 9012 3456',
  ],
  [
    'Kazakhstan (Казахстан)',
    'kz',
    '7',
    '771 000 9998',
    1,
  ],
  [
    'Kenya',
    'ke',
    '254',
    '0712 123456',
  ],
  [
    'Kiribati',
    'ki',
    '686',
    '72012345',
  ],
  [
    'Kosovo',
    'xk',
    '383',
    '',
  ],
  [
    'Kuwait (‫الكويت‬‎)',
    'kw',
    '965',
    '500 12345',
  ],
  [
    'Kyrgyzstan (Кыргызстан)',
    'kg',
    '996',
    '0700 123 456',
  ],
  [
    'Laos (ລາວ)',
    'la',
    '856',
    '020 23 123 456',
  ],
  [
    'Latvia (Latvija)',
    'lv',
    '371',
    '21 234 567',
  ],
  [
    'Lebanon (‫لبنان‬‎)',
    'lb',
    '961',
    '71 123 456',
  ],
  [
    'Lesotho',
    'ls',
    '266',
    '5012 3456',
  ],
  [
    'Liberia',
    'lr',
    '231',
    '077 012 3456',
  ],
  [
    'Libya (‫ليبيا‬‎)',
    'ly',
    '218',
    '091 2345678',
  ],
  [
    'Liechtenstein',
    'li',
    '423',
    '660 234 567',
  ],
  [
    'Lithuania (Lietuva)',
    'lt',
    '370',
    '8 612 34567',
  ],
  [
    'Luxembourg',
    'lu',
    '352',
    '628 123 456',
  ],
  [
    'Macau (澳門)',
    'mo',
    '853',
    '6612 3456',
  ],
  [
    'Macedonia (FYROM) (Македонија)',
    'mk',
    '389',
    '072 345 678',
  ],
  [
    'Madagascar (Madagasikara)',
    'mg',
    '261',
    '032 12 345 67',
  ],
  [
    'Malawi',
    'mw',
    '265',
    '0991 23 45 67',
  ],
  [
    'Malaysia',
    'my',
    '60',
    '012 345 6789',
  ],
  [
    'Maldives',
    'mv',
    '960',
    '771 2345',
  ],
  [
    'Mali',
    'ml',
    '223',
    '65 01 23 45',
  ],
  [
    'Malta',
    'mt',
    '356',
    '9696 1234',
  ],
  [
    'Marshall Islands',
    'mh',
    '692',
    '235 1234',
  ],
  [
    'Martinique',
    'mq',
    '596',
    '0696 20 12 34',
  ],
  [
    'Mauritania (‫موريتانيا‬‎)',
    'mr',
    '222',
    '22 12 34 56',
  ],
  [
    'Mauritius (Moris)',
    'mu',
    '230',
    '5251 2345',
  ],
  [
    'Mayotte',
    'yt',
    '262',
    '0639 12 34 56',
    1,
  ],
  [
    'Mexico (México)',
    'mx',
    '52',
    '044 222 123 4567',
  ],
  [
    'Micronesia',
    'fm',
    '691',
    '350 1234',
  ],
  [
    'Moldova (Republica Moldova)',
    'md',
    '373',
    '0621 12 345',
  ],
  [
    'Monaco',
    'mc',
    '377',
    '06 12 34 56 78',
  ],
  [
    'Mongolia (Монгол)',
    'mn',
    '976',
    '8812 3456',
  ],
  [
    'Montenegro (Crna Gora)',
    'me',
    '382',
    '067 622 901',
  ],
  [
    'Montserrat',
    'ms',
    '1664',
    '664 492 3456',
  ],
  [
    'Morocco (‫المغرب‬‎)',
    'ma',
    '212',
    '0650 123456',
    0,
  ],
  [
    'Mozambique (Moçambique)',
    'mz',
    '258',
    '82 123 4567',
  ],
  [
    'Myanmar (Burma) (မြန်မာ)',
    'mm',
    '95',
    '09 212 3456',
  ],
  [
    'Namibia (Namibië)',
    'na',
    '264',
    '081 123 4567',
  ],
  [
    'Nauru',
    'nr',
    '674',
    '555 1234',
  ],
  [
    'Nepal (नेपाल)',
    'np',
    '977',
    '984 1234567',
  ],
  [
    'Netherlands (Nederland)',
    'nl',
    '31',
    '06 12345678',
  ],
  [
    'New Caledonia (Nouvelle-Calédonie)',
    'nc',
    '687',
    '75 12 34',
  ],
  [
    'New Zealand',
    'nz',
    '64',
    '021 123 4567',
  ],
  [
    'Nicaragua',
    'ni',
    '505',
    '8123 4567',
  ],
  [
    'Niger (Nijar)',
    'ne',
    '227',
    '93 12 34 56',
  ],
  [
    'Nigeria',
    'ng',
    '234',
    '0802 123 4567',
  ],
  [
    'Niue',
    'nu',
    '683',
    '1234',
  ],
  [
    'Norfolk Island',
    'nf',
    '672',
    '3 81234',
  ],
  [
    'North Korea (조선 민주주의 인민 공화국)',
    'kp',
    '850',
    '0192 123 4567',
  ],
  [
    'Northern Mariana Islands',
    'mp',
    '1670',
    '670 234 5678',
  ],
  [
    'Norway (Norge)',
    'no',
    '47',
    '406 12 345',
    0,
  ],
  [
    'Oman (‫عُمان‬‎)',
    'om',
    '968',
    '9212 3456',
  ],
  [
    'Pakistan (‫پاکستان‬‎)',
    'pk',
    '92',
    '0301 2345678',
  ],
  [
    'Palau',
    'pw',
    '680',
    '620 1234',
  ],
  [
    'Palestine (‫فلسطين‬‎)',
    'ps',
    '970',
    '0599 123 456',
  ],
  [
    'Panama (Panamá)',
    'pa',
    '507',
    '6001 2345',
  ],
  [
    'Papua New Guinea',
    'pg',
    '675',
    '681 2345',
  ],
  [
    'Paraguay',
    'py',
    '595',
    '0961 456789',
  ],
  [
    'Peru (Perú)',
    'pe',
    '51',
    '912 345 678',
  ],
  [
    'Philippines',
    'ph',
    '63',
    '0905 123 4567',
  ],
  [
    'Poland (Polska)',
    'pl',
    '48',
    '512 345 678',
  ],
  [
    'Portugal',
    'pt',
    '351',
    '912 345 678',
  ],
  [
    'Puerto Rico',
    'pr',
    '1',
    '787 234 5678',
    3,
    ['787', '939'],
  ],
  [
    'Qatar (‫قطر‬‎)',
    'qa',
    '974',
    '3312 3456',
  ],
  [
    'Réunion (La Réunion)',
    're',
    '262',
    '0692 12 34 56',
    0,
  ],
  [
    'Romania (România)',
    'ro',
    '40',
    '0712 345 678',
  ],
  [
    'Russia (Россия)',
    'ru',
    '7',
    '912 345 67 89',
    0,
  ],
  [
    'Rwanda',
    'rw',
    '250',
    '0720 123 456',
  ],
  [
    'Saint Barthélemy',
    'bl',
    '590',
    '0690 30 1234',
    1,
  ],
  [
    'Saint Helena',
    'sh',
    '290',
    '51234',
  ],
  [
    'Saint Kitts and Nevis',
    'kn',
    '1869',
    '765 2917',
  ],
  [
    'Saint Lucia',
    'lc',
    '1758',
    '284 5678',
  ],
  [
    'Saint Martin (Saint-Martin (partie française))',
    'mf',
    '590',
    '0690 30 1234',
    2,
  ],
  [
    'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    'pm',
    '508',
    '055 12 34',
  ],
  [
    'Saint Vincent and the Grenadines',
    'vc',
    '1784',
    '430 1234',
  ],
  [
    'Samoa',
    'ws',
    '685',
    '601234',
  ],
  [
    'San Marino',
    'sm',
    '378',
    '66 66 12 12',
  ],
  [
    'São Tomé and Príncipe (São Tomé e Príncipe)',
    'st',
    '239',
    '981 2345',
  ],
  [
    'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    'sa',
    '966',
    '051 234 5678',
  ],
  [
    'Senegal (Sénégal)',
    'sn',
    '221',
    '70 123 45 67',
  ],
  [
    'Serbia (Србија)',
    'rs',
    '381',
    '060 1234567',
  ],
  [
    'Seychelles',
    'sc',
    '248',
    '2 510 123',
  ],
  [
    'Sierra Leone',
    'sl',
    '232',
    '025 123456',
  ],
  [
    'Singapore',
    'sg',
    '65',
    '8123 4567',
  ],
  [
    'Sint Maarten',
    'sx',
    '1721',
    '520 5678',
  ],
  [
    'Slovakia (Slovensko)',
    'sk',
    '421',
    '0912 123 456',
  ],
  [
    'Slovenia (Slovenija)',
    'si',
    '386',
    '031 234 567',
  ],
  [
    'Solomon Islands',
    'sb',
    '677',
    '74 21234',
  ],
  [
    'Somalia (Soomaaliya)',
    'so',
    '252',
    '7 1123456',
  ],
  [
    'South Africa',
    'za',
    '27',
    '071 123 4567',
  ],
  [
    'South Korea (대한민국)',
    'kr',
    '82',
    '010 0000 0000',
  ],
  [
    'South Sudan (‫جنوب السودان‬‎)',
    'ss',
    '211',
    '0977 123 456',
  ],
  [
    'Spain (España)',
    'es',
    '34',
    '612 34 56 78',
  ],
  [
    'Sri Lanka (ශ්‍රී ලංකාව)',
    'lk',
    '94',
    '071 234 5678',
  ],
  [
    'Sudan (‫السودان‬‎)',
    'sd',
    '249',
    '091 123 1234',
  ],
  [
    'Suriname',
    'sr',
    '597',
    '741 2345',
  ],
  [
    'Svalbard and Jan Mayen',
    'sj',
    '47',
    '412 34 567',
    1,
  ],
  [
    'Swaziland',
    'sz',
    '268',
    '7612 3456',
  ],
  [
    'Sweden (Sverige)',
    'se',
    '46',
    '070 123 45 67',
  ],
  [
    'Switzerland (Schweiz)',
    'ch',
    '41',
    '078 123 45 67',
  ],
  [
    'Syria (‫سوريا‬‎)',
    'sy',
    '963',
    '0944 567 890',
  ],
  [
    'Taiwan (台灣)',
    'tw',
    '886',
    '0912 345 678',
  ],
  [
    'Tajikistan',
    'tj',
    '992',
    '917 12 3456',
  ],
  [
    'Tanzania',
    'tz',
    '255',
    '0621 234 567',
  ],
  [
    'Thailand (ไทย)',
    'th',
    '66',
    '081 234 5678',
  ],
  [
    'Timor-Leste',
    'tl',
    '670',
    '7721 2345',
  ],
  [
    'Togo',
    'tg',
    '228',
    '90 11 23 45',
  ],
  [
    'Tokelau',
    'tk',
    '690',
    '7290',
  ],
  [
    'Tonga',
    'to',
    '676',
    '771 5123',
  ],
  [
    'Trinidad and Tobago',
    'tt',
    '1868',
    '291 1234',
  ],
  [
    'Tunisia (‫تونس‬‎)',
    'tn',
    '216',
    '20 123 456',
  ],
  [
    'Turkey (Türkiye)',
    'tr',
    '90',
    '0501 234 56 78',
  ],
  [
    'Turkmenistan',
    'tm',
    '993',
    '8 66 123456',
  ],
  [
    'Turks and Caicos Islands',
    'tc',
    '1649',
    '231 1234',
  ],
  [
    'Tuvalu',
    'tv',
    '688',
    '901234',
  ],
  [
    'U.S. Virgin Islands',
    'vi',
    '1340',
    '642 1234',
  ],
  [
    'Uganda',
    'ug',
    '256',
    '0712 345678',
  ],
  [
    'Ukraine (Україна)',
    'ua',
    '380',
    '039 123 4567',
  ],
  [
    'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    'ae',
    '971',
    '050 123 4567',
  ],
  [
    'United Kingdom',
    'gb',
    '44',
    '07400 123456',
    0,
  ],
  [
    'United States',
    'us',
    '1',
    '201 555 0123',
    0,
  ],
  [
    'Uruguay',
    'uy',
    '598',
    '094 231 234',
  ],
  [
    'Uzbekistan (Oʻzbekiston)',
    'uz',
    '998',
    '8 91 234 56 78',
  ],
  [
    'Vanuatu',
    'vu',
    '678',
    '591 2345',
  ],
  [
    'Vatican City (Città del Vaticano)',
    'va',
    '39',
    '312 345 6789',
    1,
  ],
  [
    'Venezuela',
    've',
    '58',
    '0412 1234567',
  ],
  [
    'Vietnam (Việt Nam)',
    'vn',
    '84',
    '091 234 56 78',
  ],
  [
    'Wallis and Futuna (Wallis-et-Futuna)',
    'wf',
    '681',
    '50 12 34',
  ],
  [
    'Western Sahara (‫الصحراء الغربية‬‎)',
    'eh',
    '212',
    '0650 123456',
    1,
  ],
  [
    'Yemen (‫اليمن‬‎)',
    'ye',
    '967',
    '0712 345 678',
  ],
  [
    'Zambia',
    'zm',
    '260',
    '095 5123456',
  ],
  [
    'Zimbabwe',
    'zw',
    '263',
    '071 123 4567',
  ],
  [
    'Åland Islands',
    'ax',
    '358',
    '041 2345678',
    1,
  ],
];

// loop over all of the countries above
for (let i = 0; i < AllCountries.length; i += 1) {
  const c = AllCountries[i];
  AllCountries[i] = {
    name: c[0],
    iso2: c[1].toUpperCase(),
    dialCode: c[2],
    dialNumber: c[3],
    priority: c[4] || 0,
    areaCodes: c[5] || null,
    icon: `https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/${c[1].toUpperCase()}.png`,
  };
}

export default AllCountries;



// WEBPACK FOOTER //
// ./src/utils/AllContriesPhoneCode.js